import { Col, type ColProps } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import InputField from '../../../../components/fields/InputField';

const defaultColSpan = { lg: 8, md: 12, xs: 24 };

export type EmailinsurerIntegrationProps = {
    prefix?: string;
    colSpan?: ColProps;
    disabled?: boolean;
};

const fieldNames = ['email'] as const;

const EmailInsurerIntegration = ({
    prefix,
    colSpan = defaultColSpan,
    disabled = false,
}: EmailinsurerIntegrationProps) => {
    const { t } = useTranslation(['insurerDetails']);

    const names = useMemo(
        () =>
            Object.fromEntries(fieldNames.map(name => [name, prefix ? `${prefix}.${name}` : name])) as Record<
                (typeof fieldNames)[number],
                string
            >,
        [prefix]
    );

    return (
        <Col {...colSpan}>
            <InputField
                {...t('insurerDetails:fields.email', { returnObjects: true })}
                disabled={disabled}
                name={names.email}
                required
            />
        </Col>
    );
};

export default EmailInsurerIntegration;
